var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('page-content',[_c('h1',[_vm._v("Dashboard")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }